class ProductParamsCE {
    constructor({
        schedule,
    }) {
        this.schedule = schedule
    }

    toJSON = () => ({
        schedule: this.schedule,
    })
}

export default ProductParamsCE
